import httpService from "../httpService";

export default {
  create(form) {
    return httpService.post("/vemaybay/create", form);
  },

  findById(id) {
    return httpService.get(`/hcCaseFlight/${id}`);
  },

  findByHcCaseMaster(hcCaseMasterId) {
    let params = {hcCaseMasterId: hcCaseMasterId};
    return httpService.get("/hcCaseFlight/findByHcCaseMaster", {params: params});
  },

  approve(form) {
    return httpService.post("/vemaybay/approve", form);
  },

  update(form) {
    return httpService.post("/vemaybay/update", form);
  },

  reject(form) {
    return httpService.post("/vemaybay/approve", form);
  },

  cancel(form) {
    return httpService.post("/vemaybay/cancel", form);
  },
};



// WEBPACK FOOTER //
// ./src/services/maybay/hcCaseFlightService.js